import React from 'react';
import { Link } from 'react-router-dom';
import { FeatherX } from '@subframe/core';
import { formatPrice } from '../../utils/formatters';
import { is3DModelUrl } from '../../utils/media';
import type { CartItem } from '../../store/cartStore';

interface CartItemRowProps {
  item: CartItem;
  onRemove: (nft_token_id: string) => void;
}

export function CartItemRow({ item, onRemove }: CartItemRowProps) {
  const isExpired = item.expiration !== null && item.expiration <= Math.floor(Date.now() / 1000);
  const imageUrl = item.thumbnail_url || item.image_url || '/placeholder-nft.png';

  return (
    <div className={`flex items-center gap-3 p-3 ${isExpired ? 'opacity-60' : ''}`}>
      <Link
        to={`/nfts/${item.nft_token_id}`}
        className="flex-shrink-0"
        onClick={(e) => e.stopPropagation()}
      >
        {is3DModelUrl(imageUrl) ? (
          <div className="w-12 h-12 rounded-md bg-gradient-to-br from-neutral-100 to-neutral-200 flex items-center justify-center">
            <span className="text-lg">🧊</span>
          </div>
        ) : (
          <img
            src={imageUrl}
            alt={item.name || 'NFT'}
            className="w-12 h-12 rounded-md object-cover"
          />
        )}
      </Link>

      <div className="flex-1 min-w-0">
        <Link
          to={`/nfts/${item.nft_token_id}`}
          className="text-body-bold font-body-bold text-default-font truncate block hover:text-brand-700"
          onClick={(e) => e.stopPropagation()}
        >
          {item.name || `NFT #${item.nft_token_id.slice(-8)}`}
        </Link>
        {item.collection_name && (
          <span className="text-caption font-caption text-subtext-color truncate block">
            {item.collection_name}
          </span>
        )}
        <span className="text-body-bold font-body-bold text-brand-700 mt-0.5">
          {formatPrice(item.price_xrp)}
        </span>
        {isExpired && (
          <span className="inline-flex items-center px-1.5 py-0.5 text-xs font-semibold text-error-700 bg-error-50 rounded mt-1">
            Expired
          </span>
        )}
      </div>

      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onRemove(item.nft_token_id);
        }}
        className="flex-shrink-0 p-1 rounded hover:bg-neutral-100 transition-colors"
        aria-label="Remove from cart"
      >
        <FeatherX className="h-4 w-4 text-subtext-color" />
      </button>
    </div>
  );
}
